// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nMp8","col":"styles_col__24iGs"};